<ng-container>
	<app-ea-spinner *ngIf="!users"></app-ea-spinner>
	<!--TODO <my-error-component *ngIf="data.error" [error]="data.error"></my-error-component> -->
	<div *ngIf="users">
		<div class="flex align-items-center justify-content-between pt-3 pb-2 px-4" id="header">
			<div class="pl-3 overflow-hidden">
				<span class="block text-4xl font-bold">{{ "utilisateur.liste" | translate }}</span>
			</div>
		</div>
		<div class="col-12">
			<div class="card">
				<p-toast></p-toast>

				<p-table
					#dt
					[value]="users"
					[(selection)]="selectedUser"
					dataKey="id"
					styleClass="p-datatable-user"
					[rowHover]="true"
					[rows]="15"
					[paginator]="true"
					[filterDelay]="0"
					[globalFilterFields]="['email', 'enabled']">
					<ng-template pTemplate="caption">
						<span class="p-input-icon-left">
							<i class="pi pi-search"></i>
							<input
								pInputText
								type="text"
								(input)="dt.filterGlobal($event.target.value, 'contains')"
								placeholder="Recherche" />
						</span>
						<button
							pButton
							pRipple
							style="float: right"
							label="{{ 'user.add' | translate }}"
							icon="pi pi-user-plus"
							class="p-button-success mr-2 mb-2"
							(click)="openCreationUserDialog()"></button>
					</ng-template>
					<ng-template pTemplate="header">
						<tr>
							<th pSortableColumn="email">
								<div class="flex justify-content-between align-items-center">
									{{ "global.email" | translate }}
									<p-sortIcon field="email"></p-sortIcon>
									<p-columnFilter
										type="text"
										field="email"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
							<th pSortableColumn="enabled">
								<div class="flex justify-content-between align-items-center">
									{{ "global.etat" | translate }}
									<p-sortIcon field="enabled"></p-sortIcon>
								</div>
							</th>
							<th>{{ "change.state" | translate }}</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-user let-rowIndex="rowIndex">
						<tr class="p-selectable-row" (click)="onSelection(user)">
							<td>
								<span class="p-column-title">{{ "global.email" | translate }}</span>
								{{ user.email }}
							</td>
							<td>
								<span class="p-column-title">{{ "global.etat" | translate }}</span>
								<span *ngIf="user.enabled" class="customer-badge status-active">{{
									"etat.active" | translate
								}}</span>
								<span *ngIf="!user.enabled" class="customer-badge status-desactive">{{
									"etat.desactive" | translate
								}}</span>
							</td>
							<td class="d-flex justify-content-center align-items-center">
								<button
									*ngIf="user.enabled"
									pButton
									pRipple
									icon="pi pi-power-off"
									class="p-button-rounded p-button-danger"
									(mousedown)="updateUser(user)"></button>
								<button
									*ngIf="!user.enabled"
									pButton
									pRipple
									icon="pi pi-sync"
									class="p-button-rounded p-button-success"
									(mousedown)="updateUser(user)"></button>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="8">{{ "utilisateur.pasdutilisateur" | translate }}</td>
						</tr>
					</ng-template>
				</p-table>
				<p-dialog
					[(visible)]="showNewUserDialog"
					[style]="{ width: '450px' }"
					header="{{ 'user.create' | translate }}"
					[modal]="true"
					styleClass="p-fluid">
					<ng-template pTemplate="content">
						<div class="field">
							<label for="name">{{ "global.email" | translate }}</label>
							<input type="text" pInputText id="name" [(ngModel)]="newUser.email" required autofocus />
							<small class="p-invalid red-text" *ngIf="errorEmailType === 'emptyField'">{{
								"submit.champobligatoire" | translate
							}}</small>
						</div>
						<div class="field">
							<label class="mb-3">{{ "global.typeaccess" | translate }}</label>
							<div class="formgrid grid">
								<div class="field-checkbox col-6">
									<p-checkbox
										id="category1"
										name="category"
										value="ADMINISTRATEUR"
										[(ngModel)]="newUser.roles"></p-checkbox>
									<label for="category1">{{ "user.administrateur" | translate }}</label>
								</div>
								<div class="field-checkbox col-6">
									<p-checkbox
										id="category2"
										name="category"
										value="ELEVEUR"
										[(ngModel)]="newUser.roles"></p-checkbox>
									<label for="category2">{{ "user.eleveur" | translate }}</label>
								</div>
							</div>
							<small class="p-invalid red-text" *ngIf="errorRoleType === 'noRoles'">{{
								"submit.champobligatoire" | translate
							}}</small>
						</div>
					</ng-template>

					<ng-template pTemplate="footer">
						<button
							pButton
							pRipple
							label="{{ 'global.annuler' | translate }}"
							icon="pi pi-times"
							class="p-button-text"
							(click)="hideCreationUserDialog()"></button>
						<button
							pButton
							pRipple
							label="{{ 'global.enregistrer' | translate }}"
							icon="pi pi-check"
							class="p-button-text"
							(click)="createUser()"></button>
					</ng-template>
				</p-dialog>
				<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
			</div>
		</div>
	</div>
</ng-container>
